import classNames from 'classnames';

import { Button, ButtonProps } from '../../Button';

import styles from './ActionBlock.module.scss';

interface ActionBlockProps {
  actions?: ButtonProps[];
  gridActions?: boolean;
  buttonAlignment?: 'left' | 'center' | 'right';
  className?: string;
}

export const ActionBlock = ({
  actions,
  gridActions,
  buttonAlignment = 'center',
  className,
}: ActionBlockProps) => {
  if (!actions?.length) return null;

  let actionsToMap: ButtonProps[] = [];
  let lastAction: ButtonProps | undefined;

  if (gridActions && actions?.length % 2 === 1) {
    actionsToMap = actions.slice(0, -1) || [];
    lastAction = actions?.slice(-1)[0];
  } else {
    actionsToMap = actions || [];
  }

  return (
    <div className={classNames(styles.masterButtonGrid, className)}>
      <div
        className={`${gridActions ? styles.buttonGrid : styles.buttonRow} ${
          styles[buttonAlignment]
        }`}>
        {actions?.length &&
          actionsToMap.map((action, index) => {
            return (
              <div key={index}>
                <Button {...action} className={gridActions ? styles.setWidth : ''} />
              </div>
            );
          })}
      </div>
      {lastAction && (
        <div className={styles.lastButtonDiv}>
          <Button {...lastAction} />
        </div>
      )}
    </div>
  );
};
